// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.about.AboutInfoItem
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class AboutInfoItem {
  static createAboutInfoItem(name, value, zone) {
    const retVal = new AboutInfoItem();
    retVal.initAboutInfoItem(name, value, zone);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createAboutInfoItem factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawada.AboutInfoItem";
  }
  initFromJson(json, deserializeContext) {
    this.initAboutInfoItem(json.name != null ? json.name : null, json.value != null ? json.value : null, json.zone != null ? json.zone : null);
  }
  initAboutInfoItem(name, value, zone) {
    this._name = name;
    this._value = value;
    this._zone = zone;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["name"] = this._name;
    retVal["value"] = this._value;
    if (this._zone != null) {
      retVal["zone"] = this._zone;
    }
    return retVal;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
  get zone() {
    return this._zone;
  }
  set zone(value) {
    this._zone = value;
  }
}
//# sourceMappingURL=AboutInfoItem.js.map
